export class RadReportContainer extends HTMLElement
{
    $thumbsUpDownRater = null;

    constructor ()
    {
        super();

    }

    connectedCallback ()
    {
        this.init();
    }

    init ()
    {
        const feedbackHeader = document.querySelector('.feedback-header');
        const downloadPdfBtn = this.createDownloadPdfBtn();
        feedbackHeader.appendChild(downloadPdfBtn);
        this.thumbsUpDownRater = this.createThumbsUpDownRater();
        feedbackHeader.appendChild(this.thumbsUpDownRater);

        this.initEventHandlers();

    }

    createDownloadPdfBtn()
    {
        const downloadPdfDiv = document.createElement('div');
        downloadPdfDiv.classList.add('download-pdf-container');
        const downloadPDFBtn = document.createElement('a');
        downloadPDFBtn.classList.add('download-pdf');
        downloadPDFBtn.href = this.dataset.pdf_link + "?report_access_source_id=2";
        downloadPDFBtn.setAttribute('target', '_blank');


        const svg = document.createElement('material-design-svg');
        svg.setAttribute('data-icon', 'outlined__download_for_offline');
        svg.dataset.iconSize = '24';

        downloadPDFBtn.appendChild(svg);
        const btnText = document.createElement('span');
        btnText.classList.add('download-btn-text');
        btnText.textContent = "Download PDF";
        downloadPDFBtn.appendChild(btnText);

        downloadPdfDiv.appendChild(downloadPDFBtn);

        return downloadPdfDiv;
    }

    createThumbsUpDownRater ()
    {
        const thumbsUpDownRater = document.createElement('thumbs-up-down-rater');
        thumbsUpDownRater.dataset.report_id = this.dataset.report_id;
        thumbsUpDownRater.dataset.report_title = 'Radiologist Report';
        thumbsUpDownRater.dataset.report_type = 'rad';
        return thumbsUpDownRater;

    }

    initEventHandlers()
    {
    }

}

customElements.define('rad-report-container', RadReportContainer);
